import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=a2c49a4a&scoped=true&"
import script from "./Farm.vue?vue&type=script&lang=js&"
export * from "./Farm.vue?vue&type=script&lang=js&"
import style0 from "./Farm.vue?vue&type=style&index=0&id=a2c49a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c49a4a",
  null
  
)

export default component.exports